<template>
  <div class="icon-navbar">
    <s-notification-dot
      v-if="notificationCounter"
      cluster="k"
      variant="danger"
      class="counter"
      :style="{ '--text-length': Math.min(3, String(notificationCounter).length) }"
      :count="notificationCounter"
    />
    <img id="notification_icon" src="https://cdn.karier.mu/assets/v3/icon/notifikasi.svg" />
    <b-tooltip target="notification_icon" variant="warning" triggers="hover">Notifikasi</b-tooltip>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'IconNotifikasi',
  methods: {
    resetNotifCounter () {
      this.$store.commit('notification/SET_NEW_NOTIF', false)
    }
  },
  computed: {
    ...mapState('notification', ['notificationCounter'])
  }
}
</script>

<style scoped>
.icon-navbar {
  cursor: pointer;
  position: relative;
}
.counter{
  position: absolute;
  top: -5px;
  left: calc(50% - var(--text-length) * 15%);
  height: fit-content;
  width: fit-content;
}
</style>
